<template>
    <div>
        <loader v-if="isLoading" />
        <div v-else>
            <p v-if="errorMessage !== ''">{{ errorMessage }}</p>
            <div v-else class="list">
                <b-row>
                    <b-col>
                        <b>Patient (ID):</b>
                    </b-col>
                    <b-col>
                        <b>Image:</b>
                    </b-col>
                    <b-col cols="2">
                        <b>Study Date:</b>
                    </b-col>
                    <b-col cols="1" />
                </b-row>

                <div v-if="list.length > 0">
                    <b-row
                        v-for="record in list"
                        :key="record.id"
                        class="row-record d-flex align-items-center"
                    >
                        <b-col>
                            <router-link
                                v-if="
                                    record.patient &&
                                    record.patient.encodedId &&
                                    isUsingViewProfile
                                "
                                :to="`/patient/profile/${record.patient.encodedId}`"
                            >
                                {{ properPatientName(record) }}
                            </router-link>
                            <a
                                v-else-if="
                                    record.patient &&
                                    record.patient.encodedId &&
                                    !isUsingViewProfile
                                "
                                :href="
                                    CIAPPS +
                                    'patient/patient/view/' +
                                    record.patient.encodedId
                                "
                            >
                                {{ properPatientName(record) }}
                            </a>
                            <span v-else>
                                {{ properPatientName(record) }}
                            </span>
                        </b-col>
                        <b-col v-html="getLink(record)">
                            <!-- <a :href="record.editor_link" target="_blank">
                                View Online ({{ record.source }})
                            </a> -->
                        </b-col>
                        <b-col cols="2">
                            {{
                                record.study_date
                                    ? _setDateDisplay(Number(record.study_date))
                                    : "--"
                            }}
                        </b-col>
                        <b-col cols="1" class="text-right">
                            <b-dropdown size="sm" variant="link" right no-caret>
                                <template v-slot:button-content>
                                    <i class="cus-cog-down"></i>
                                </template>
                                <b-dropdown-item @click="assignImage(record)">
                                    <i class="cus-page-white-edit"></i>
                                    Assign Image
                                </b-dropdown-item>

                                <b-dropdown-item @click="deleteImage(record)">
                                    <i class="cus-delete"></i> Delete Image
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <b-row class="row-record">
                        <b-col>
                            <i>No records available.</i>
                        </b-col>
                    </b-row>
                </div>
            </div>

            <b-pagination
                class="vet-pagination"
                align="right"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                prev-text="Prev"
                next-text="Next"
                :hide-goto-end-buttons="true"
                @change="changePage"
            ></b-pagination>
        </div>

        <modal-delete
            ref="modalDelete"
            :reloadAfter="true"
            :businessId="businessId"
            @reloadlist="fetchList(1)"
        />

        <modal-assign
            ref="modalAssign"
            :reloadAfter="true"
            :businessId="businessId"
            @reloadlist="fetchList(1)"
        />
    </div>
</template>

<script>
import { forEach } from "lodash";
import modalDelete from "./modal-delete";
import modalAssign from "./modal-assign";

export default {
    components: {
        modalDelete,
        modalAssign,
        Loader: () => import("@/components/elements/loader-list")
    },
    props: {
        businessId: {
            type: String,
            required: true
        },
        isUsingViewProfile: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            currentPage: 1,
            totalRows: 0,
            perPage: 0,
            isLoading: true,
            errorMessage: "",
            list: [],
            CIAPPS: process.env.CI_APPS
        };
    },
    watch: {
        businessId(value) {
            if (value !== "") {
                this.fetchList(1);
            }
        }
    },
    mounted() {
        this.fetchList(1);
    },
    methods: {
        async fetchList(page) {
            if (this.businessId === "") {
                return;
            }

            this.isLoading = true;
            this.errorMessage = "";

            try {
                const res = await this.$http.get(
                    `${process.env.BARRAMUNDI}record/unassign-image/${this.businessId}`,
                    {
                        params: {
                            page: page
                        }
                    }
                );

                this.isLoading = false;

                if (res.data.response.message.code === 200) {
                    const { resources, meta } = res.data.response;
                    this.list = resources;
                    this.totalRows = meta.total;
                    this.perPage = meta.perPage;
                    this.currentPage = page;
                } else {
                    throw new Error("Unable to get unassigned lab list.");
                }
            } catch (e) {
                this.isLoading = false;
                this.errorMessage = "Error: " + e.message;
            }
        },
        properPatientName(record = {}) {
            const { animal_name, animal_id, patient } = record;

            if (patient && patient.name) {
                return `${patient.name} (${patient.index})`;
            }

            if (animal_name && animal_id) {
                return `${animal_name} (${animal_id})`;
            }

            return null;
        },
        assignImage(record) {
            this.$refs.modalAssign.open({
                recordId: record.id,
                module: record.source,
                patientId: (record.patient) ? record.patient.id : null,
                studyId: record.study_id
            });
        },
        deleteImage(record) {
            this.$refs.modalDelete.open({
                recordId: record.id,
                source: record.source
            });
        },
        changePage(page) {
            this.fetchList(page);
        },
        getLink(record) {
            var module = "";

            if (record.source == "ASTERIS") {
                module = "Asteris";
            } else if (record.source == "IDEXX_DR") {
                module = "IDEXX";
            } else {
                module = "Vetology";
            }

            var link =
                '<p><a href="' +
                record.editor_link +
                '" target="_blank">View Online (' +
                module +
                ")</a><p>";
            if (record.source == "ASTERIS" && record.reports) {
                if (_.isArray(record.reports)) {
                    forEach(record.reports, object => {
                        link +=
                            '<p><a href="' +
                            object.url +
                            '" target="_blank">' +
                            object.title +
                            "</a><p>";
                    });
                }
            }

            if (
                _.isArray(record.vetology_unassigned) &&
                record.vetology_unassigned.length
            ) {
                link += "<div>Vetology:</div>";
                forEach(record.vetology_unassigned, object => {
                    link +=
                        '<div><a href="' +
                        object.link +
                        '" target="_blank">' +
                        object.filename +
                        "</a><div>";
                });
            }

            return link;
        }
    }
};
</script>

<style scoped>
.initials {
    display: block;
    margin-bottom: 20px;
}
.list {
    margin: 0 15px 10px 15px;
}
.row-record {
    padding: 6px 0;
    border-bottom: 1px solid #ddd;
}
.row-record:hover {
    background-color: #f5f5f5;
}
.vet-pagination {
    margin-top: 50px;
}
</style>
